const Emoji_H = {
    ':ha': { id: 325, width: 18, height: 18 },
    ':hammer_1': { id: 275, width: 40, height: 21 },
    ':hammer': { id: 276, width: 30, height: 26 },
    ':happy': { id: 278, width: 20, height: 20 },
    ':happybirth': { id: 277, width: 40, height: 28 },
    ':harhar': { id: 279, width: 34, height: 26 },
    ':hat': { id: 280, width: 26, height: 21 },
    ':hb': { id: 281, width: 28, height: 29 },
    ':heart': { id: 282, width: 19, height: 19 },
    ':hehe': { id: 283, width: 20, height: 20 },
    ':hello': { id: 285, width: 18, height: 18 },
    ':helpsmilie': { id: 284, width: 35, height: 25 },
    ':hi': { id: 285, width: 31, height: 28 },
    ':hippi': { id: 286, width: 40, height: 28 },
    ':hit': { id: 287, width: 43, height: 22 },
    ':hitler': { id: 288, width: 20, height: 20 },
    ':hmm': { id: 289, width: 18, height: 18 },
    ':holloween': { id: 290, width: 18, height: 18 },
    ':horns': { id: 291, width: 33, height: 25 },
    ':horny': { id: 27, width: 20, height: 20 },
    ':hug': { id: 292, width: 47, height: 18 },
    ':huh': { id: 293, width: 20, height: 20 },
}

export default Emoji_H
